import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import {
  RecoverPasswordModel,
  ResetPasswordResult,
} from "../../../../model/onboarding/forgot_password/RecoverPasswordModel";
import ShowToast from "../../../../widget/common/ui/Toast";

const RecoverPasswordProvider = new (class RecoverPasswordProvider {
  navigateNewPassword = () => {
    navigate(appRoutes.routeNameNewPassword, { replace: true });
  };

  submitSendAPI = async ({
    emailAddress = "",
    mobileCodeId = "",
    mobileCode = "",
    mobileNumber = "",
    flag = "0",
  }: {
    emailAddress?: string;
    mobileCodeId?: string;
    mobileCode?: string;
    mobileNumber?: string;
    flag: "0" | "1"; // // 0-email, 1-mobile
  }): Promise<boolean> => {
    ApiUrls.init();

    const url: string = `${ApiUrls.baseUrl}profile/recover_password`;
    const body: any = {
      email: emailAddress,
      flag: flag,
      mobile_code_id: mobileCodeId,
      mobile_number: mobileNumber,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const recoverPasswordModel: RecoverPasswordModel = response;
        const resetPasswordResult: ResetPasswordResult =
          recoverPasswordModel?.result?.reset_password_result!;

        console.log(resetPasswordResult);
        // SignupResult Model Setup
        SessionStorage.saveValue(
          StorageKeys.recover_password_detail,
          JSON.stringify({
            account_id: resetPasswordResult?.profile_id!,
            email: emailAddress,
            mobile_code_id: mobileCodeId,
            mobile_code: mobileCode,
            mobile_number: `${mobileCode}${mobileNumber}`,
            verif_code: resetPasswordResult?.reset_code!,
            expiry_date: resetPasswordResult?.code_expiry!,
            status: resetPasswordResult?.status!,
          })
        );

        SessionStorage.saveValue(
          StorageKeys.verification_type,
          flag === "0" ? "email" : "phone"
        );

        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default RecoverPasswordProvider;
